module.exports = __webpack_public_path__ + "zilky-v-obliceji_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/zilky-v-obliceji_2_before_tn.jpg
// module id = 1464
// module chunks = 0